import {
  ColumnDef,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table"
import { AdminTrack } from "@/types/shared"
import BasicTable from "@/shared/tables/BasicTable"

export const tracksColumns: ColumnDef<AdminTrack>[] = [
  {
    accessorKey: "name",
    header: "Name",
  },
  {
    accessorKey: "city",
    header: "City",
  },
  {
    accessorKey: "state",
    header: "State",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "country",
    header: "Country",
  },
  {
    accessorKey: "manager_count",
    header: "Managers",
    cell: (info) => {
      const value = info.getValue()
      return value === 0 ? "—" : value
    },
  },
]

interface TracksTableProps {
  tracks: AdminTrack[]
  onRowClick: (track: AdminTrack) => void
}

export default function TracksTable({ tracks, onRowClick }: TracksTableProps) {
  const table = useReactTable({
    data: tracks,
    columns: tracksColumns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  return <BasicTable table={table} handleRowOnClick={(row) => onRowClick(row.original)} />
}
